import React from 'react';

export const ButtonWithIcon = ({ icon, text }) => {
  return (
    <button className="flex w-full md:w-auto bg-secondary-500 active:bg-secondary-900 rounded-lg p-3 justify-center px-6 items-center space-x-2">
      {icon}
      <span className="text-base font-bold">{text}</span>
    </button>
  );
};

export default ButtonWithIcon;
